var map = {
	"./1_Felicitas Ernst_fotografia - Azlo - Laveta (4).webp": "./src/img/brands/laveta/1_Felicitas Ernst_fotografia - Azlo - Laveta (4).webp",
	"./Felicitas Ernst_fotografia - Azlo - Laveta (17).webp": "./src/img/brands/laveta/Felicitas Ernst_fotografia - Azlo - Laveta (17).webp",
	"./Felicitas Ernst_fotografia - Azlo - Laveta (24).webp": "./src/img/brands/laveta/Felicitas Ernst_fotografia - Azlo - Laveta (24).webp",
	"./Felicitas Ernst_fotografia - Azlo - Laveta (33).webp": "./src/img/brands/laveta/Felicitas Ernst_fotografia - Azlo - Laveta (33).webp",
	"./Felicitas Ernst_fotografia - Azlo - Laveta (34).webp": "./src/img/brands/laveta/Felicitas Ernst_fotografia - Azlo - Laveta (34).webp",
	"./Felicitas Ernst_fotografia - Azlo - Laveta (48).webp": "./src/img/brands/laveta/Felicitas Ernst_fotografia - Azlo - Laveta (48).webp",
	"./Felicitas Ernst_fotografia - Azlo - Laveta (53).webp": "./src/img/brands/laveta/Felicitas Ernst_fotografia - Azlo - Laveta (53).webp",
	"./Felicitas Ernst_fotografia - Azlo - Laveta (7).webp": "./src/img/brands/laveta/Felicitas Ernst_fotografia - Azlo - Laveta (7).webp",
	"./_MG_7997.webp": "./src/img/brands/laveta/_MG_7997.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/laveta sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";